import { eachYearOfInterval, format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { Chart } from 'react-chartjs-2';
import { useLocation } from 'react-router-dom';
import { TablePadrão, Td, Tr } from '../../../../components/develop-nilton-components/TablePadrão';
import { SectionHeader } from '../../../../components/SectionHeader';
import { SpinnerLoading } from '../../../../components/SpinnerLoading';
import { SubmitResponse } from '../../../../components/SubmitResponse';
import api from '../../../../services/api';
import { TbodyPageHistorico } from './TbodyPageHistorico';

export function PageHistoricoPsicopedagogo() {
  const headWidth = ["5%", "50%", "30%", "30%"];
  const thead = ["#", "Nome do psicopedagogo", "Data da consulta", "Relatório"];
  const [data, set_data] = useState(null);
  const [load, setLoad] = useState(false);
  const types = [
    { label: "Obediência", value: "obdece_comandos_primeira_vez" },
    { label: "Concentração", value: "dificuldade_memorizacao_concentracao" },
    { label: "Expressão", value: "consegue_expressar_pensamentos" },
    { label: "Aprendizagem", value: "dificuldade_aprendizagem" },

    { label: "Adaptação", value: "dificuldade_adaptacao" },
    { label: "Irritação", value: "irrita_facilmente" },
    { label: "Reclamação", value: "reclama_muito" },
    { label: "Agressivo", value: "agressivo" },
    { label: "Desempenho", value: "preocupa_apresentar_bom_desempenho" },
    { label: "Voz", value: "voz_modulada_ritmo_adequado" },
    { label: "Familia", value: "preocupacao_familiar_especifica" },
    { label: "Cooperação", value: "cooperador" },
    { label: "Sociavel", value: "satisfatoriamente_sociavel" },
    { label: "Disciplina", value: "disciplinado" },
  ];

  const [year, setYear] = useState(new Date().toLocaleDateString("pt-BR", { year: "numeric" }));
  const [type, setType] = useState("obdece_comandos_primeira_vez");

  const year_options = eachYearOfInterval({ start: new Date(0), end: new Date() }).map((year) => format(year, "yyyy")).reverse();

  const { state } = useLocation<any>();

  function handle_set_data(type:string, year: string) {
    setLoad(true);
    api.get('/reports/acompanhamento_psicopedagico_anual_egresso', {
      params: {
        egress_id: state.id,
        year,
        type,
      },
    }).then(({ data }) => {
      set_data(data);
      setLoad(false);
    });
  }

  useEffect(() => {
    handle_set_data(type, year);
  }, [state.id, type, year]);
  return (
    <div className="w-100" data-testid="page-historico">
      <SectionHeader backPage="/acompanhamento" subtitle="Indicadores Individuais" />

      <div>
        {load && !data && <div className="d-flex justify-content-center m-5"><SpinnerLoading /></div>}
        {data && (
          <div className="d-flex align-items-center flex-column">
            <div>
              <h3 className="d-flex" style={{ gap: 10 }}>
                Tipo de gráfico anual:
                <select style={{ width: 300 }} className="form-control" onChange={(e) => setType(e.target.value)}>
                  {types.map((type, i) => (
                    <option key={i} value={type.value}>{type.label}</option>
                  ))}
                </select>
                {load && <div className="m-0"><SpinnerLoading size={10} /></div>}
              </h3>
              {/* <h3 className="d-flex" style={{ gap: 10 }}>
                Ano:
                <select style={{ width: 300 }} className="form-control" onChange={(e) => setYear(e.target.value)}>
                  {year_options.map((year, i) => (
                    <option key={i} value={year}>{year}</option>
                  ))}
                </select>
                {load && <div className="m-0"><SpinnerLoading size={10} /></div>}
              </h3> */}
            </div>

            <div style={{ width: "100%" }}>
              <Chart
                type="line"
                data={data}
                options={{
                  plugins: {
                    legend: { display: false },
                  },
                  scales: {
                    y: {
                      suggestedMax: 10,
                      suggestedMin: 0,
                    },
                  },
                }}
              />
            </div>
          </div>
        )}
      </div>

      <h3 className="text-primary mt-5">
        Nome do egresso:
        {' '}
        {state.nome}
      </h3>

      <TablePadrão
        headWidth={headWidth}
        thead={thead}
      >
        {state?.acompanhamentos_psicopedagogicos.concluidos.length === 0 && (
          <Tr>
            <Td width="100%">
              <div className="w-100">
                <SubmitResponse submitResponse={{
                  message: "Não há acompanhamentos.",
                  status: "danger",
                  title: "Aviso",
                }}
                />
              </div>
            </Td>
          </Tr>
        )}
        {state.acompanhamentos_psicopedagogicos.concluidos.map((item:any, i:number) => (
          <TbodyPageHistorico
            egresso={state}
            headWidth={headWidth}
            index={i + 1}
            acompanhamento_concluidos={item}
          />
        ))}
      </TablePadrão>
    </div>
  );
}
